module.exports = __webpack_public_path__ + "img/logo.fd91d412.png";